var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.GenericAcceptPolicy
  }, _vm._l(_vm.policies, function (item) {
    var _item$file;
    return _c(_setup.SCheckbox, {
      key: item.documentSlug,
      class: _vm.$style.checkbox,
      attrs: {
        "theme": "secondary"
      },
      model: {
        value: _setup.v$.form[item.documentSlug].$model,
        callback: function callback($$v) {
          _vm.$set(_setup.v$.form[item.documentSlug], "$model", $$v);
        },
        expression: "v$.form[item.documentSlug].$model"
      }
    }, [_c('span', {
      class: _vm.$style.text
    }, [_vm._v("\n      Нажимая на кнопку я подтверждаю, что принимаю условия документа\n      "), (_item$file = item.file) !== null && _item$file !== void 0 && _item$file.aws ? _c('a', {
      attrs: {
        "href": item.file.aws,
        "target": "_blank"
      }
    }, [_vm._v("\n        " + _vm._s(item.documentName) + "\n      ")]) : _c('NuxtLink', {
      attrs: {
        "target": _vm.target,
        "to": _setup.getLink(item.documentSlug)
      }
    }, [_vm._v("\n        " + _vm._s(item.documentName) + "\n      ")])], 1)]);
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };